<div class="container d-flex align-items-center justify-content-center" style="min-height: 100vh;">
    <img src="/assets/images/404 Error-bro.svg" width="450px" height="400px" alt="404 Not found">
</div>